<template>
	<div class="lbt_box">
		
		<img class="lbt_img" src="../static/home/bg1.png" alt="" v-show="num==0||num==1">
		<img class="lbt_img" src="../static/home/bg2.png" alt="" v-show="num==1||num==2">
		<img class="lbt_img" src="../static/home/bg3.png" alt="" v-show="num==2||num==3">
		<img class="lbt_img" src="../static/home/bg4.png" alt="" v-show="num==3">
		
		<div class="gradual_1" v-if="num==0">
			<img class="ctgz_1" src="../static/home/lb1.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					站在茶山上，<br>千亩茶园犹如碧波翻滚，<br>漫无边际。
				</div>
			</div>
		</div>
		
		<div class="gradual_1" v-if="num==1">
			<img class="ctgz_1" src="../static/home/lb2.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					这生机盎然的景色，<br>仿佛从蓝天裁剪的一角青蓝，<br>它妖娆了这方多姿多彩的山水。
				</div>
			</div>
		</div>
		
		<div class="gradual_1" v-if="num==2">
			<img class="ctgz_1" src="../static/home/lb3.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					一座戏楼斗拱飞檐，<br>凌驾于任河碧波之上，<br>宛若飞去。
				</div>
			</div>
		</div>
		
		<div class="gradual_1" v-if="num==3">
			<img class="ctgz_1" src="../static/home/lb4.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					飞檐斗拱，雕梁画栋，<br>殿的飞檐饰物栩栩如生，<br>堪称清代江南建筑艺术的瑰宝。
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tirm : null,	//定时器
				num : 0,		//第几个
				
				
				imgs:[],		//轮播图
			}
		},
		created() {
			this.Rotation();
			
			// this.$axios({	//图片
			// 		url:"/api"+"/site/banner/list",//请求的后台接口
			// 		method:"get",//get请求方式
			// 		headers:{
			// 			'User-Request-Type': 'riesun_site', 
			// 			'siteid' : 'riesun_site_caa20f63ab704743b21741ba133e8499',
			// 			'sitesecret' : '03569e80-00b6-4540-9e65-0a53f0f2ab7e',
			// 		},
					
			// 	}).then(res=>{
			// 		console.log(res.data.rows)
			// 			// this.imgs = res.data.rows
			// 　　//请求成功
			// }).catch(error=>{
			// 		console.log(error)
			// });
		},
		methods:{
			Rotation(){
				var that = this
				this.tirm = setInterval(function(){
					if(that.num<3){
						that.num++ 
					}else{
						that.num=0
					}
				},9000)
			},
			
		},
		
		beforeDestroy(){	//退出页面时间
			clearInterval(this.tirm)
			this.tirm = null;
			
			
		}
		
	}
</script>

<style scoped lang="less">
	.lbt_box{
		width: 1920px;
		height: 100%;
		background-color: #30446a;
		
		position: relative;
		
	}
	
	// 
	.lbt_img{
		position: absolute;
		top: 0;
		left: 0;
		transition: 1s all;
		width: 1920px;
		height: 100%;
		object-fit: cover;
		background-repeat: no-repeat;
		animation: bgimg 12s;
		animation-fill-mode: forwards;
	}
		@keyframes bgimg{
			0%{
				transform: scale(1.2);
				opacity: 1;
			}
			25%{
				transform: scale(1);
				opacity: 1;
				z-index: 2;
			}
			75%{
				transform: scale(1);
				opacity: 1;
				z-index: 3;
			}
			100%{
				transform: scale(1.2);
				opacity: 0;
				z-index: 3;
			}
		}
	
	// 
	.gradual_1{
		position: absolute;
		z-index: 10;
		left: 660px;
		top: 30%;
		transform:translateY(-50px);
	}
	.ctgz_1{
		height: 260px;
		position: absolute;
		top: 0;
		right: 0;
		opacity: 0;
		animation: ctgzdh 2s;
		animation-fill-mode: forwards;
	}
		@keyframes ctgzdh{
			0%{
				transform: scale(1.2);
				opacity: 0;
			}
			100%{
				transform: scale(1);
				opacity: 1;
			}
		}
	.text_1box{
		position: absolute;
		top: 23px;
		right: 300px;
	}
	.text_1{
		font-size: 28px;
		color: #fff;
		line-height: 36px;
		letter-spacing: 3px;
		writing-mode: vertical-rl;
		opacity: 0;
		animation: textdh 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
		font-family: 'wy';
	}
		@keyframes textdh{
			0%{
				transform:translateX(-50%);
				opacity: 0;
			}
			100%{
				opacity: 1;
			}
		}
	// 
	
</style>